import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import { FiLogOut } from "react-icons/fi";
import { Fragment, useState } from "react";
import { IoCarOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert, useAxios } from "../../hooks";
import { RiDeleteBin6Line } from "react-icons/ri";
import DeleteIcon from "@mui/icons-material/Delete";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { PiUserSwitchDuotone } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlinePersonAddAlt1 } from "react-icons/md";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import { MdErrorOutline } from "react-icons/md";

import { Box, Button, Card, Divider, Grid, Typography } from "@mui/material";

import Dependent from "./Dependent";
import StageStepper from "./Stepper";
import icon from "./assests/Group.svg";
import pages from "../../constants/pages";
import GenerateQRDialog from "./GenerateQR";
import AddEmailIDDialog from "./AddEmailID";
import emptyImg from "./assests/emptyImg.svg";
import DeleteDetailsDialog from "./DeleteDetails";
import DeleteDependentDialog from "./DeleteDependent";
import verifiedIcon from "./assests/VerifiedIcon.svg";
import UserBackGround from "./assests/UserBackGround.svg";
import AddParkingVechiclePop from "./AddParkingVechiclePop";
import { signOutMember } from "../../redux/slices/memberSlice";
import ConsentListDialog from "./ConsentList";
import SwitchProfile from "./SwitchProfile";
import useDeviceInfo from "../../hooks/useDeviceInfo";

const PageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  align-items: baseline !important;
`;

const ProfileContainer = styled(Card)`
  width: '100%',
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  backdropFilter: 'blur(10px)',
`;

const HeaderButton = styled(Button)`
  &:hover {
  }
`;

const ProfileImage = styled("img")(() => ({
  width: "50%",
  height: "25vh",
  borderRadius: "100%",
  border: "2px solid #3936ef",
  zIndex: 9999,
}));

const EmptyImgIcon = styled("img")(() => ({
  zIndex: 999999,
  borderRadius: "100%",
  border: "2px solid #3936ef",
  marginTop: "35px",
}));

export default function Profile() {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { visitorData } = useSelector((state) => state.memberDetails);

  // const { browser, os, deviceType, errors } = useDeviceInfo();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const digiLockerID = queryParams.get("id");

  const [userData, setUserData] = useState({});
  const [userImage, setUserImage] = useState("");
  const [openDependent, setOpenDependent] = useState(false);
  const [generateQRPopUp, setGenerateQRPopUp] = useState(false);
  const [addEmailIDPopUp, setAddEmailIDPopUp] = useState(false);
  const [parkingDetailsList, setParkingDetailsList] = useState([]);
  const [selectDependentId, setSelectDependentId] = useState(false);
  const [deleteDetailsPopUp, setDeleteDetailsPopUp] = useState(false);
  const [addParkingDetialPop, setAddOpenParkingPop] = useState(false);
  const [switchProfilePop, setSwitchProfilePop] = useState(false);
  const [consentListPopUp, setConsentListPopUp] = useState(false);
  const [deleteDependentPopUp, setDeleteDependentPopUp] = useState(false);
  const [dependentList, setDependentList] = useState(visitorData.dependentList);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorData.ID) && !item.includes("userPayload");
  });

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorData.ID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorData.ID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    axios({
      url: "admin/profile/decrypt-face-data",
      method: "POST",
      disableRedirect: true,
      data: {
        face_data: localStorage.getItem(digipassDataKey[0]),
      },
    }).then((response) => {
      if (response.status) {
        setUserImage(response.data);
      } else {
        setUserImage("");
      }
    });

    axios({
      url:
        "event/visitor/get-dependent-list?phone_number=" +
        visitorData.phoneNumber,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setDependentList(response.data || []);
      }
    });
  }, [visitorData.ID, axios, dispatch]);

  useEffect(() => {
    if (
      userData?.student_details?.student_id ||
      userData?.employee_details?.employee_id
    ) {
      axios({
        url: `/admin/parking/user-parking-details?booking_id=${
          userData?.student_details?.student_id ||
          userData?.employee_details?.employee_id
        }`,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setParkingDetailsList(response.data);
        }
      });
    }
  }, [visitorData.ID, userData, axios, dispatch]);

  useEffect(() => {
    axios({
      url: "admin/profile/get-visitor-detail?visitor_id=" + visitorData.ID,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setUserData(response.data);
      }
    });
  }, [visitorData.ID]);

  const handleDeleteData = () => {
    axios({
      url: `admin/profile/delete-face-data?visitor_id=${visitorData.ID}`,
      method: "DELETE",
    }).then((response) => {
      if (response.status) {
        dispatch(signOutMember());
        localStorage.clear();
        navigate(pages.home.route);
      }
      setDeleteDetailsPopUp(false);
    });
  };

  const handleDeleteParkingVehicle = (ID) => {
    axios({
      url: "/admin/parking/delete-visitor-parking?visitor_id=" + visitorData.ID,
      method: "POST",
      data: { vehicle_number: ID },
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        axios({
          url: "admin/profile/get-visitor-detail?visitor_id=" + visitorData.ID,
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            setUserData(response.data);
          }
        });
      }
    });
  };

  const handleDeleteDependent = () => {
    axios({
      url: `event/visitor/delete-dependent?visitor_id=${selectDependentId}`,
      method: "DELETE",
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({ message: response.message.displayMessage, type: "success" })
        );
        axios({
          url:
            "event/visitor/get-dependent-list?phone_number=" +
            visitorData.phoneNumber,
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            setDependentList(response.data || []);
          }
        });
      }

      setDeleteDependentPopUp(false);
    });
  };

  return (
    <PageWrapper>
      <ProfileContainer
        sx={{
          boxShadow: "none",
          "@media (min-width: 950px)": {
            width: "50%",
          },
        }}
        elevation={0}
      >
        <Grid
          container
          spacing={2}
          sx={{ borderRadius: "10px", background: "white" }}
        >
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems={"center"}
            sx={{ zIndex: "999" }}
          >
            <Grid item container sx={{ width: 0 }} className="eventImageBox">
              <div
                style={{
                  position: "relative",
                }}
              >
                <img className="profileBackBanner" style={{}} src={icon} />
              </div>
            </Grid>

            <Grid
              item
              container
              mb={"25px"}
              style={{
                zIndex: "9999999",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <Grid
                item
                display={"flex"}
                onClick={() => {
                  navigate(pages.home.route);
                }}
              >
                <IoIosArrowBack
                  color="#A9A9A9"
                  fontSize={"24px"}
                  style={{ margin: "0px 20px 0px 10px" }}
                />
                <Typography variant="body1" fontSize={"18px"} fontWeight={500}>
                  Edit Profile
                </Typography>
              </Grid>

              <Grid
                item
                sx={{
                  marginRight: "10px",
                  background: "#f1f1f1",
                  borderRadius: "7.5px",
                }}
              >
                {/* <SwitchProfileButton
                  dependentList={dependentList || visitorData?.dependentList}
                /> */}
              </Grid>
            </Grid>

            {userImage ? (
              <Fragment>
                <Grid
                  item
                  container
                  justifyContent={"center"}
                  position={"relative"}
                >
                  <ProfileImage
                    src={`data:image/jpeg;base64,${userImage}`}
                    alt="Profile"
                  />
                  <QrCodeIcon
                    sx={{
                      fontSize: "45px",
                      padding: "6px",
                      borderRadius: "9px",
                      background: "white",
                      position: "absolute",
                      alignSelf: "end",
                      marginLeft: "30%",
                      zIndex: "9999999999999999999",
                      boxShadow: "0px 0px 5px 2px #6868688a",
                    }}
                    onClick={() => {
                      setGenerateQRPopUp(true);
                    }}
                  />
                </Grid>
              </Fragment>
            ) : (
              <EmptyImgIcon src={emptyImg} />
            )}

            <Grid container justifyContent={"center"} mt={2.5}>
              <Typography variant="body1" fontSize={"18px"} fontWeight={900}>
                {`${visitorData.firstName ? visitorData.firstName : ""} ${
                  visitorData.lastName ? visitorData.lastName : ""
                }`}
              </Typography>
            </Grid>

            {userImage && (
              <Grid container justifyContent={"center"} mt={2.5}>
                <Grid
                  item
                  xs={3.5}
                  sx={{
                    border: "1px solid #0000001A",
                    borderRadius: "40px",
                    display: "flex",
                    justifyContent: "space-evenly",
                    padding: "6px 3px",
                    alignItems: "center",
                  }}
                >
                  <Fragment>
                    <img src={verifiedIcon} width={"17px"} height={"17px"} />
                    <Typography
                      variant="body1"
                      sx={{ fontSize: "12px" }}
                      fontWeight={700}
                    >
                      Verified
                    </Typography>
                  </Fragment>
                </Grid>
              </Grid>
            )}

            {!userImage && (
              <Grid container justifyContent={"center"} mt={2.5}>
                <Grid
                  item
                  xs={3.5}
                  sx={{
                    border: "1px solid #0000001A",
                    borderRadius: "40px",
                    display: "flex",
                    justifyContent: "space-evenly",
                    padding: "6px 3px",
                    alignItems: "center",
                  }}
                >
                  <PrivacyTipIcon
                    style={{ fontSize: "17px", color: "rgb(219 11 11)" }}
                  />

                  <Typography
                    variant="body1"
                    sx={{ fontSize: "12px" }}
                    fontWeight={700}
                  >
                    Not Verified
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid
            container
            sx={{
              border: "0.6px solid #0000001A",
              borderRadius: "16px",
              margin: "20px",
              position: "relative",
            }}
          >
            <img
              src={UserBackGround}
              style={{ position: "absolute", right: 0 }}
            ></img>
            <Grid item xs={12} sx={{ padding: "15px !important" }}>
              {!!visitorData.gender && (
                <Grid item container>
                  <Grid item xs={6}>
                    <Typography variant="body1" fontWeight={"bold"}>
                      Gender
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1">
                      {visitorData.gender}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {!!visitorData.phoneNumber && (
                <Grid item container m={"15px 0px"}>
                  <Grid item xs={6}>
                    <Typography variant="body1" fontWeight={"bold"}>
                      Phone Number
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1">
                      {visitorData.phoneNumber}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {!visitorData.emailID && (
                <Grid item container m={"15px 0px"}>
                  <Grid item xs={6}>
                    <Typography variant="body1" fontWeight={"bold"}>
                      Email Id
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {visitorData.email_Id ? (
                      <Typography variant="body1">
                        {visitorData.email_Id}
                      </Typography>
                    ) : (
                      <LoadingButton
                        variant="outlined"
                        onClick={() => setAddEmailIDPopUp(true)}
                      >
                        Add email id
                      </LoadingButton>
                    )}
                  </Grid>
                </Grid>
              )}

              {!!visitorData.emailID && (
                <Grid item container>
                  <Grid item xs={6}>
                    <Typography variant="body1" fontWeight={"bold"}>
                      Email ID
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body1">
                      {visitorData.emailID}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            sx={{
              border: "0.6px solid #0000001A",
              borderRadius: "16px",
              margin: "0px 20px",
              padding: "15px 0px 10px",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 900, marginBottom: "5px" }}
            >
              Verification Status
            </Typography>
            <StageStepper userData={userData} />
          </Grid>

          {Object.keys(userData?.student_details || []).length > 0 && (
            <Grid
              item
              container
              sx={{
                border: "0.6px solid #0000001A",
                borderRadius: "16px",
                padding: "15px !important",
                backgroundColor: "#ffd0d0",
                backgroundImage:
                  "linear-gradient(164deg, rgb(232 232 255) 3%, rgb(255, 255, 255) 31%)",
                margin: "20px",
              }}
            >
              <Grid item container m={"0px 0px 15px"}>
                <Typography
                  variant="body1"
                  fontSize={"14px"}
                  fontWeight={"900"}
                  color={"#00000080"}
                >
                  STUDENT PASS
                </Typography>
              </Grid>

              <Grid item container m={"15px 0px"}>
                <Typography variant="body1">Campus Name</Typography>&ensp; :
                &nbsp;
                <Typography variant="body1">
                  {userData?.student_details?.campus_name}
                </Typography>
              </Grid>

              <Grid item container>
                <Typography variant="body1">Course</Typography>&ensp; : &nbsp;
                <Typography variant="body1">
                  {userData?.student_details?.course}
                </Typography>
              </Grid>

              <Grid item container mt={"25px"}>
                <HeaderButton
                  variant="outlined"
                  fullWidth
                  onClick={() => navigate(pages.CampusUserPage.route)}
                >
                  View
                </HeaderButton>
              </Grid>
            </Grid>
          )}

          {Object.keys(userData?.employee_details || []).length > 0 && (
            <Grid
              item
              container
              sx={{
                border: "0.6px solid #0000001A",
                borderRadius: "16px",
                padding: "15px !important",
                backgroundColor: "#ffd0d0",
                backgroundImage:
                  "linear-gradient(164deg, rgb(232 232 255) 3%, rgb(255, 255, 255) 31%)",
                margin: "20px",
              }}
            >
              <Grid item container alignItems={"center"}></Grid>
              <Grid item container m={"0px 0px 15px"}>
                <Typography
                  variant="body1"
                  fontSize={"14px"}
                  fontWeight={"900"}
                  color={"#00000080"}
                >
                  EMPLOYEE PASS
                </Typography>
              </Grid>

              <Grid item container m={"15px 0px"}>
                <Typography variant="body1">Designation</Typography>&ensp; :
                &nbsp;
                <Typography variant="body1">
                  {userData?.employee_details?.designation}
                </Typography>
              </Grid>

              <Grid item container>
                <Typography variant="body1">Employee ID</Typography>&ensp; :
                &nbsp;
                <Typography variant="body1">
                  {userData?.employee_details?.employee_id}
                </Typography>
              </Grid>

              {/* <Grid item container mt={"25px"}>
                <HeaderButton
                  variant="outlined"
                  fullWidth
                  // onClick={() => handleVerifyProfile(visitorData.ID)}
                >
                  View
                </HeaderButton>
              </Grid> */}
            </Grid>
          )}

          {/* <Grid
            item
            container
            sx={{
              border: "0.6px solid #0000001A",
              borderRadius: "16px",
              padding: "15px !important",
              backgroundColor: "#ffd0d0",
              backgroundImage:
                "linear-gradient(164deg, rgb(232 232 255) 3%, rgb(255, 255, 255) 31%)",
              margin: "20px",
            }}
          >
            <ParkingDetialsPopup
              ID={visitorData.ID}
              setUserData={setUserData}
            />
          </Grid> */}

          {(parkingDetailsList?.length > 0 ||
            userData?.vehicle_numbers?.length > 0) && (
            <Grid
              item
              container
              sx={{
                border: "0.6px solid #0000001A",
                borderRadius: "16px",
                padding: "15px !important",
                backgroundColor: "#ffd0d0",
                backgroundImage:
                  "linear-gradient(164deg, rgb(232 232 255) 3%, rgb(255, 255, 255) 31%)",
                margin: "20px",
              }}
            >
              <Grid item container m={"0px 0px 15px"}>
                <Typography
                  variant="body1"
                  fontSize={"14px"}
                  fontWeight={"900"}
                  color={"#00000080"}
                >
                  Parking Vehicle
                </Typography>
              </Grid>

              {(parkingDetailsList?.length > 0
                ? parkingDetailsList
                : userData.vehicle_numbers
              )?.map((item, index) => {
                return (
                  <Fragment>
                    {item?.vehicle_number ? (
                      <Grid item container>
                        <Typography variant="body1">
                          {`${index + 1} `}Vehicle
                        </Typography>
                        &ensp; : &nbsp;
                        <Typography variant="body1">
                          {item?.vehicle_number} {item?.vehicle_type}
                        </Typography>
                      </Grid>
                    ) : (
                      <Grid item container m={"5px 0px"}>
                        <Grid item container xs={10}>
                          <Typography variant="body1">
                            {`${index + 1} `}Vehicle
                          </Typography>
                          &ensp; : &nbsp;
                          <Typography variant="body1">{item}</Typography>
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          onClick={() => handleDeleteParkingVehicle(item)}
                        >
                          <DeleteIcon sx={{ color: "red" }} />
                        </Grid>
                      </Grid>
                    )}
                  </Fragment>
                );
              })}
            </Grid>
          )}
        </Grid>

        {/* {Boolean(dependentList?.length) && (
          <Fragment>
            <Grid container padding={"15px 28px"}>
              <Typography variant="h6" fontWeight={"bolder"} fontSize={"17px"}>
                Dependants {`( ${dependentList.length} )`}
              </Typography>

              {dependentList?.map((item, index) => {
                return (
                  <Fragment>
                    <Grid
                      item
                      container
                      spacing={2}
                      sx={{
                        border: "0.6px solid #0000001A",
                        borderRadius: "8px",
                        marginTop: "7px",
                        background: "white",
                        marginTop: "15px",
                      }}
                    >
                      <Grid item container p={"7.5px 0px"}>
                        <Grid item container p={"4.5px 12.5px 5px 4.5px"}>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              alignSelf: "center",
                            }}
                          >
                            <img
                              width={"20px"}
                              src={
                                "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/2c3a1f49ab5f419da2b5542744edc32f/1740720646322_No_Image_Available.jpg"
                              }
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "45%",
                              }}
                            ></img>
                          </Grid>
                          <Grid
                            item
                            xs={7}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <Typography
                              variant="body1"
                              fontWeight={"bolder"}
                              fontSize={"14px"}
                            >
                              {item.first_name + item.last_name}
                            </Typography>

                            <Typography
                              variant="body1"
                              fontWeight={400}
                              fontSize={"12px"}
                            >
                              {item.phone_number}
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            xs={3}
                            sx={{
                              display: "flex",
                              justifyContent: "end",
                              borderRadius: "4px",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              setDeleteDependentPopUp(true);
                              setSelectDependentId(item._id);
                            }}
                          >
                            <RiDeleteBin6Line
                              style={{
                                width: "20px",
                                height: "20px",
                                color: "#919191",
                              }}
                            />
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          container
                          justifyContent={"center"}
                          m={"5px 0px"}
                        >
                          <Divider
                            sx={{
                              background: "#0000000F",
                              width: "90.5%",
                            }}
                          />
                        </Grid>

                        <Grid item container justifyContent={"center"}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 900,
                              marginTop: "5px",
                              marginBottom: "5px",
                              textAlign: "center",
                            }}
                          >
                            Verification Status
                          </Typography>
                        </Grid>

                        <StageStepper userData={item} />
                      </Grid>
                    </Grid>
                  </Fragment>
                );
              })}
            </Grid>
          </Fragment>
        )} */}

        <Grid container padding={"0px 28px 28px 28px"}>
          <Typography variant="h6" fontWeight={600} sx={{ marginTop: "15px" }}>
            Actions
          </Typography>
          <Grid
            item
            container
            marginBottom={"15px"}
            sx={{
              border: "0.6px solid #0000001A",
              borderRadius: "8px",
              marginTop: "15px",
            }}
          >
            <Grid item container p={"5px"}>
              <Grid item container p={"5px 10px 10px 15px"}>
                <Grid
                  item
                  xs={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <MdOutlinePersonAddAlt1
                    style={{
                      width: "25px",
                      height: "25px",
                      marginRight: "10px",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={8.5}
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => {
                    setOpenDependent(true);
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={900}
                    fontSize={"14px"}
                  >
                    Add a Dependant
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={1.5}
                  sx={{
                    display: "flex",
                    justifyContent: "center",

                    borderRadius: "4px",
                    padding: "7px 0px",
                  }}
                  onClick={() => {
                    // window.location.replace(eventDetail?.address.map_link);
                  }}
                >
                  <IoIosArrowForward fontSize={"20px"} color="#919191" />
                </Grid>
              </Grid>

              {/* <Fragment>
                {" "}
                <Grid item container justifyContent={"center"}>
                  <Divider
                    sx={{
                      background: "#0000000F",
                      width: "90.5%",
                    }}
                  />
                </Grid>
                <Grid item container p={"5px 10px 10px 15px"}>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <IoCarOutline
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "10px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={8.5}
                    sx={{ display: "flex", alignItems: "center" }}
                    onClick={() => {
                      setAddOpenParkingPop(true);
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={900}
                      fontSize={"14px"}
                    >
                      Add Parking Vehicle
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={1.5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",

                      borderRadius: "4px",
                      padding: "7px 0px",
                    }}
                    onClick={() => {
                      // window.location.replace(eventDetail?.address.map_link);
                    }}
                  >
                    <IoIosArrowForward fontSize={"20px"} color="#919191" />
                  </Grid>
                </Grid>
              </Fragment> */}

              {/* <Fragment>
                {" "}
                <Grid item container justifyContent={"center"}>
                  <Divider
                    sx={{
                      background: "#0000000F",
                      width: "90.5%",
                    }}
                  />
                </Grid>
                <Grid item container p={"5px 10px 10px 15px"}>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <PiUserSwitchDuotone
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "10px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={8.5}
                    sx={{ display: "flex", alignItems: "center" }}
                    onClick={() => {
                      setSwitchProfilePop(true);
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={900}
                      fontSize={"14px"}
                    >
                      Switch Profile
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={1.5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",

                      borderRadius: "4px",
                      padding: "7px 0px",
                    }}
                    onClick={() => {
                      // window.location.replace(eventDetail?.address.map_link);
                    }}
                  >
                    <IoIosArrowForward fontSize={"20px"} color="#919191" />
                  </Grid>
                </Grid>
              </Fragment> */}

              {/* <Fragment>
                {" "}
                <Grid item container justifyContent={"center"}>
                  <Divider
                    sx={{
                      background: "#0000000F",
                      width: "90.5%",
                    }}
                  />
                </Grid>
                <Grid item container p={"5px 10px 10px 15px"}>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <MdErrorOutline
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "10px",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={8.5}
                    sx={{ display: "flex", alignItems: "center" }}
                    onClick={() => {
                      setConsentListPopUp(true);
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={900}
                      fontSize={"14px"}
                    >
                      All Consent
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={1.5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",

                      borderRadius: "4px",
                      padding: "7px 0px",
                    }}
                    onClick={() => {
                      // window.location.replace(eventDetail?.address.map_link);
                    }}
                  >
                    <IoIosArrowForward fontSize={"20px"} color="#919191" />
                  </Grid>
                </Grid>
              </Fragment> */}

              {userImage && (
                <Fragment>
                  <Grid item container justifyContent={"center"}>
                    <Divider
                      sx={{
                        background: "#0000000F",
                        width: "90.5%",
                      }}
                    />
                  </Grid>

                  <Grid item container p={"5px 10px 10px 15px"}>
                    <Grid
                      item
                      xs={2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <RiDeleteBin6Line
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "10px",
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={8.5}
                      sx={{ display: "flex", alignItems: "center" }}
                      onClick={() => {
                        setDeleteDetailsPopUp(true);
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={900}
                        fontSize={"14px"}
                        color={"#CD0000"}
                        onClick={() => {
                          setDeleteDetailsPopUp(true);
                        }}
                      >
                        Delete All Details
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={1.5}
                      sx={{
                        display: "flex",
                        justifyContent: "center",

                        borderRadius: "4px",
                        padding: "7px 0px",
                      }}
                      onClick={() => {}}
                    >
                      <IoIosArrowForward fontSize={"20px"} color="#919191" />
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </Grid>

          <Grid
            item
            container
            marginBottom={"15px"}
            sx={{
              border: "0.6px solid #b40000",
              borderRadius: "8px",
              background: "#b61e1e0d",
            }}
            onClick={() => {
              dispatch(signOutMember());

              navigate(pages.home.route);
            }}
          >
            <Grid item container p={"5px"}>
              <Grid item container p={"5px 10px 10px 15px"}>
                <Grid
                  item
                  xs={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <FiLogOut
                    style={{
                      width: "25px",
                      height: "25px",
                      marginRight: "10px",
                      color: "#b40000",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={8.5}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={900}
                    fontSize={"14px"}
                    color={"#b40000"}
                  >
                    Log out
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Dependent
          openDependent={openDependent}
          setOpenDependent={setOpenDependent}
          setDependentList={setDependentList}
        />

        <DeleteDependentDialog
          handleDeleteDependent={handleDeleteDependent}
          deleteDependentPopUp={deleteDependentPopUp}
          setDeleteDependentPopUp={setDeleteDependentPopUp}
        />

        <DeleteDetailsDialog
          handleDeleteData={handleDeleteData}
          deleteDetailsPopUp={deleteDetailsPopUp}
          setDeleteDetailsPopUp={setDeleteDetailsPopUp}
        />

        <AddEmailIDDialog
          addEmailIDPopUp={addEmailIDPopUp}
          setAddEmailIDPopUp={setAddEmailIDPopUp}
        />

        <GenerateQRDialog
          userImage={userImage}
          generateQRPopUp={generateQRPopUp}
          setGenerateQRPopUp={setGenerateQRPopUp}
        />

        <AddParkingVechiclePop
          ID={visitorData.ID}
          setUserData={setUserData}
          addParkingDetialPop={addParkingDetialPop}
          setAddOpenParkingPop={setAddOpenParkingPop}
        />

        <ConsentListDialog
          consentListPopUp={consentListPopUp}
          setConsentListPopUp={setConsentListPopUp}
        />

        <SwitchProfile
          switchProfilePop={switchProfilePop}
          setSwitchProfilePop={setSwitchProfilePop}
          dependentList={dependentList || visitorData?.dependentList}
          setDeleteDependentPopUp={setDeleteDependentPopUp}
          setSelectDependentId={setSelectDependentId}
        />
      </ProfileContainer>
    </PageWrapper>
  );
}
